import request from './.request'
//查询
export function getInputData(id,e) {
  return request({
    url: `/inputs/${id}?about=enterprise`,
    method:'get',
    params:e
  })
}
//添加
export function insertInput(e) {
  return request({
    url: `/input-plan`,
    method:'post',
    data:e
  })
}
// 删除
export function deletetInput(e) {
  return request({
    url: `/input-plan`,
    method:'delete',
    params:e
  })
}
// 更新
export function updateInput(e) {
  return request({
    url: `/input-plan`,
    method:'put',
    data:e
  })
}

/**
 * 根据投入品类型查询所有下拉选
 * */
export function inputsByType(enterpriseId,type) {
  return request({
    url: `/input-plan/${enterpriseId}?about=input&type=${type}`,
    method:'get',
  })
}
/**
 * 根据条件查询投入计划
 * */
export function inputsPlan(e) {
  return request({
    url: `/input-plan`,
    method:'get',
    params:e
  })
}



// WEBPACK FOOTER //
// ./src/api/input-plan.js